import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=1f301918&scoped=true"
import script from "./NotificationCenter.vue?vue&type=script&lang=js"
export * from "./NotificationCenter.vue?vue&type=script&lang=js"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=1f301918&prod&scoped=true&lang=css"
import style1 from "./NotificationCenter.vue?vue&type=style&index=1&id=1f301918&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f301918",
  null
  
)

export default component.exports